module.exports = __webpack_public_path__ + "img/Flag_of_the_United_Kingdom.0b2080d0.svg";